import * as React from 'react';

import * as style from './style.css';
import { UIHeading2 } from '@cian/ui-kit';

interface INewbuildingPromoCarouselLayoutProps {
  children?: React.ReactNode;
  title: string;
}

export function NewbuildingPromoCarouselLayout({ children, title }: INewbuildingPromoCarouselLayoutProps) {
  return (
    <div className={style['container']} data-testid="NewbuildingPromoCarouselLayout">
      <div className={style['container--inner']}>
        <UIHeading2 data-testid="NewbuildingPromoCarouselTitle">{title}</UIHeading2>
        {children}
      </div>
    </div>
  );
}
